<template>
	<div class="captail_wrap registrationSteps position-relative fullLoader p-0 w-100">
		 
		<div class="middle_section m-0">
			<div class="top_searchbars">
				<div class="row">
					<div class="col-12">
						<div class="cap_logo_steps centerLogo p-3 d-flex justify-content-between align-items-center">
							 <router-link to="/home"><img src="../../../../../static/website/images/logo.svg" alt="Captail wallet"></router-link>
							<div class="rightBack d-flex align-items-center">
							<router-link class="backToDash mr-2" :to="'/individual-step1'"><feather type="chevron-left"></feather></router-link>
							<a href="#" class="backToDash" @click.prevent="logout()">Logout</a>
							<!-- <router-link class="backToDash" :to="'/home'"><feather type="home"></feather></router-link> -->
						    </div>
						</div>
					</div>
				</div>
			</div>
			<div class="mid_scroll_content d-flex align-items-center justify-content-center">
				<section class="stepsForm-include valigncenter border-0 w-100">
					<div class="row justify-content-center">
						<div class="col-12 col-lg-7 stepBorder box-shadow text-center">
							<loader v-if="pageLoader"></loader>
							<alert-notification v-if="notification_msg != ''"/>
							<h3 class="text-center mb-4">Acknowledgements</h3>
							<p><strong>We also require you to accept our terms & conditions, and to agree to our processing of your personal data</strong></p>
							<div class="mt-3 mt-md-5 lisiChkbox">
								<ul class="acknowledgements">
									<li>
										<p>I agree to {{$env_var.productName}} <a :href="$env_var.terms_use" target="_blank">Terms of Use</a> and <a :href="$env_var.privacy_policy" target="_blank">Privacy Policy</a> and confirm that I am over 18 years of age. <span v-if="submitted && !check1" class="text-danger">This is required</span></p>
										<label class="customCheckbox">
											<input type="checkbox" v-model="check1" name="check1" v-validate="'required'">
											<span class="checkmark"></span>
											
										</label>
									</li>
									<li>
										<p>You acknowledge potential for financial losses may result from extreme market volatility, hardware or software limitations or failure, government action, or delays in deposits and withdrawals to your account.<span v-if="submitted && !check2 " class="text-danger">This is required</span></p>
										<label class="customCheckbox">
											<input type="checkbox" v-model="check2" name="check2" v-validate="'required'">
											<span class="checkmark"></span>
										</label>
									</li>
									<li>
										<p>You acknowledge that any disputes will be resolved informally or through the use of binding arbitration held.<span v-if="submitted && !check3" class="text-danger">This is required</span></p>
										<label class="customCheckbox">
											<input type="checkbox" v-model="check3"  name="check3" v-validate="'required'">
											<span class="checkmark"></span>
										</label>
									</li>
								</ul>
								<div class="submitButton text-center mt-5">
									<input type="button" class="cap_btn blue px-4 large_btn" value="Submit" :class="(pageLoader)?'disabled':''" v-on:click.stop.prevent="submit">
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
	</div>
</template>

<script>
import { registerStepsMixins } from '@/plugins/registerSteps'
export default {
    name: 'step-five',
	mixins: [registerStepsMixins],
    data() {
        return {
			terms_agreed : '1',
			pageLoader : false,
			notification_msg:'',
            notification_type:'',
			submitted : false,
			check1:false,
			check2:false,
			check3:false
		}
    },
	methods: {
		submit(){
			if(this.pageLoader){return;}
			const _that = this
			this.submitted = true;
			this.$validator.validate().then(valid => {
				if (valid) {
					_that.terms_agreed = (_that.check1 == true && _that.check2 == true && _that.check3 == true)? '1' : '0'
					let input_json={
						'globalParams' :{"terms_agreed" :_that.terms_agreed, 'step' : '2'},
						'localParams' :{ "parameter" : _that }
					}
					_that._runStep5(input_json)
				}
			})
		}
	},
	created(){
		this._runGetStepInfo({'globalParams' :{"step" : '2'},'localParams' :{ "parameter" : this}})
	}
}
</script>



// WEBPACK FOOTER //
// src/components/website/registerSteps/individual/individual_step2.vue